(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-video-slider')) {
    class ShoppableVideoSlider extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.cfg = {
          autoplay: d.autoplay === 'true' && !reduceMotion,
          autoSlide: d.autoSlide === 'true',
          interval: (parseFloat(d.interval) || 5) * 1000,
          mode: d.checkoutMode || 'direct',
          qty: parseInt(d.qty, 10) || 1,
          cartUrl: (d.cartUrl || '/cart').replace(/\/$/, ''),
          cartAddUrl: (d.cartAddUrl || '/cart/add').replace(/\/$/, ''),
          checkoutUrl: (d.rootUrl || '/').replace(/\/$/, '') + '/checkout',
          labels: {
            buy: d.labelBuy || 'Buy Now',
            soldOut: d.labelSoldOut || 'Sold out',
            unavailable: d.labelUnavailable || 'Unavailable',
            select: d.labelSelect || 'Please select',
            redirecting: d.labelRedirecting || 'Redirecting…',
            error: d.labelError || 'Something went wrong. Please try again.'
          }
        };

        this.track = this.querySelector('[data-svs-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('[data-svs-prev]');
        this.nextBtn = this.querySelector('[data-svs-next]');
        this.dotsWrap = this.querySelector('[data-svs-dots]');
        this.cards = Array.from(this.querySelectorAll('[data-svs-card]'));
        this.videos = Array.from(this.querySelectorAll('[data-svs-video]'));
        this.paused = false;
        this.hovering = false;
        this.inView = false;
        this.panelOpen = false;

        this.cards.forEach((card) => this.initCard(card));
        this.initVideos();
        this.initNav();
        this.initAutoSlide();
        this.initEditor();

        // Restore buttons when shoppers come back from checkout with the browser Back button
        this.onPageShow = (e) => { if (e.persisted) this.cards.forEach((c) => this.resetBuy(c)); };
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        [this.viewObs, this.visObs, this.loadObs, this.playObs, this.ro].forEach((o) => o && o.disconnect());
        clearInterval(this.timer);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      /* ---------------- Product / variant logic ---------------- */
      initCard(card) {
        const jsonEl = card.querySelector('[data-svs-product-json]');
        let data = null;
        try { data = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (e) { data = null; }

        const st = {
          data,
          variant: null,
          selects: Array.from(card.querySelectorAll('[data-svs-option]')),
          buy: card.querySelector('[data-svs-buy]'),
          toggle: card.querySelector('[data-svs-toggle]'),
          msg: card.querySelector('[data-svs-msg]'),
          toast: card.querySelector('[data-svs-toast]'),
          prices: Array.from(card.querySelectorAll('[data-svs-price]')),
          thumb: card.querySelector('[data-svs-thumb]')
        };
        card._svs = st;
        if (!data || !st.buy) return;

        st.selects.forEach((sel) => {
          sel.addEventListener('change', () => {
            sel.classList.remove('is-invalid');
            this.showMsg(card, '');
            this.updateVariant(card);
          });
        });
        st.buy.addEventListener('click', () => this.handleBuy(card));
        if (st.toggle) {
          st.toggle.addEventListener('click', () => {
            if (card.classList.contains('is-open')) this.closePanel(card);
            else this.openPanel(card);
          });
        }
        const closeBtn = card.querySelector('[data-svs-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.closePanel(card);
            if (st.toggle) st.toggle.focus();
          });
        }
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && card.classList.contains('is-open')) {
            this.closePanel(card);
            if (st.toggle) st.toggle.focus();
          }
        });

        this.updateVariant(card);
      }

      updateVariant(card) {
        const st = card._svs;
        const variants = st.data.variants || [];
        const vals = st.selects.map((s) => s.value);

        if (st.selects.length === 0) st.variant = variants[0] || false;
        else if (vals.some((v) => !v)) st.variant = null;
        else st.variant = variants.find((v) => v.options.every((o, i) => o === vals[i])) || false;

        // Mark option values that are sold out given the other current choices
        st.selects.forEach((sel, i) => {
          Array.from(sel.options).forEach((opt) => {
            if (!opt.value) return;
            const ok = variants.some((v) =>
              v.available &&
              v.options[i] === opt.value &&
              v.options.every((o, j) => j === i || !vals[j] || o === vals[j])
            );
            opt.textContent = ok ? opt.value : opt.value + ' – ' + this.cfg.labels.soldOut;
          });
        });

        if (st.variant) {
          st.prices.forEach((p) => {
            const cur = p.querySelector('[data-svs-price-current]');
            const cmp = p.querySelector('[data-svs-price-compare]');
            const from = p.querySelector('[data-svs-price-from]');
            if (cur) cur.innerHTML = st.variant.price;
            if (cmp) { cmp.innerHTML = st.variant.compare || ''; cmp.hidden = !st.variant.compare; }
            if (from) from.hidden = true;
          });
          if (st.thumb && st.variant.image) st.thumb.src = st.variant.image;
        }
        this.setBuyState(card);
      }

      setBuyState(card) {
        const st = card._svs;
        const L = this.cfg.labels;
        const label = st.buy.querySelector('[data-svs-buy-label]') || st.buy;
        st.buy.classList.remove('is-loading');
        st.buy.removeAttribute('aria-busy');

        const anyAvailable = (st.data.variants || []).some((v) => v.available);
        if (st.variant === false) {
          st.buy.disabled = true;
          label.textContent = L.unavailable;
        } else if ((st.variant && !st.variant.available) || !anyAvailable) {
          st.buy.disabled = true;
          label.textContent = L.soldOut;
        } else {
          st.buy.disabled = false;
          label.textContent = L.buy;
        }
      }

      resetBuy(card) {
        if (card._svs && card._svs.data && card._svs.buy) this.setBuyState(card);
        this.paused = false;
      }

      handleBuy(card) {
        const st = card._svs;
        if (!st.variant) {
          if (st.variant === false) return;
          // No variant chosen yet: open the picker and point at what's missing
          const missing = st.selects.filter((s) => !s.value);
          missing.forEach((s) => s.classList.add('is-invalid'));
          this.openPanel(card);
          const names = missing.map((s) => s.dataset.optionName).join(', ');
          this.showMsg(card, names ? this.cfg.labels.select + ': ' + names : this.cfg.labels.select);
          if (missing[0]) setTimeout(() => missing[0].focus({ preventScroll: true }), 320);
          return;
        }
        if (!st.variant.available) return;
        this.checkout(card, st.variant.id);
      }

      async checkout(card, id) {
        const st = card._svs;
        const L = this.cfg.labels;

        if (window.Shopify && window.Shopify.designMode) {
          this.showToast(card, 'Checkout redirect is disabled inside the theme editor. Variant ID: ' + id);
          return;
        }

        const label = st.buy.querySelector('[data-svs-buy-label]') || st.buy;
        st.buy.disabled = true;
        st.buy.classList.add('is-loading');
        st.buy.setAttribute('aria-busy', 'true');
        label.textContent = L.redirecting;
        this.paused = true;

        try {
          if (this.cfg.mode === 'cart') {
            const res = await fetch(this.cfg.cartAddUrl + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: [{ id: id, quantity: this.cfg.qty }] })
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(body.description || body.message || L.error);
            window.location.href = this.cfg.checkoutUrl;
          } else {
            // Cart permalink: goes straight to checkout with only this item
            window.location.href = this.cfg.cartUrl + '/' + id + ':' + this.cfg.qty;
          }
        } catch (err) {
          this.resetBuy(card);
          this.showToast(card, (err && err.message) || L.error);
        }
      }

      openPanel(card) {
        this.cards.forEach((c) => { if (c !== card) this.closePanel(c); });
        card.classList.add('is-open');
        if (card._svs && card._svs.toggle) card._svs.toggle.setAttribute('aria-expanded', 'true');
        this.panelOpen = true;
      }

      closePanel(card) {
        if (!card.classList.contains('is-open')) return;
        card.classList.remove('is-open');
        if (card._svs && card._svs.toggle) card._svs.toggle.setAttribute('aria-expanded', 'false');
        this.panelOpen = this.cards.some((c) => c.classList.contains('is-open'));
      }

      showMsg(card, text) {
        const el = card._svs && card._svs.msg;
        if (!el) return;
        el.textContent = text;
        el.hidden = !text;
      }

      showToast(card, text) {
        const st = card._svs;
        if (!st || !st.toast) return;
        st.toast.textContent = text;
        st.toast.hidden = false;
        clearTimeout(st.toastTimer);
        st.toastTimer = setTimeout(() => { st.toast.hidden = true; }, 4500);
      }

      /* ---------------- Video playback ---------------- */
      initVideos() {
        this.videos.forEach((v) => {
          v._svs = { loaded: false, userPaused: false };
          const media = v.closest('[data-svs-media]');
          const playBtn = media.querySelector('[data-svs-play]');
          const muteBtn = media.querySelector('[data-svs-mute]');

          const sync = () => media.classList.toggle('is-playing', !v.paused);
          v.addEventListener('play', sync);
          v.addEventListener('pause', sync);

          const toggle = () => {
            if (v.paused) { v._svs.userPaused = false; this.playVideo(v, true); }
            else { v._svs.userPaused = true; v.pause(); }
          };
          if (playBtn) playBtn.addEventListener('click', toggle);
          v.addEventListener('click', toggle);

          if (muteBtn) {
            muteBtn.addEventListener('click', () => {
              const willMute = !v.muted;
              if (!willMute) {
                document.querySelectorAll('[data-svs-video]').forEach((o) => { if (o !== v) o.muted = true; });
              }
              v.muted = willMute;
              if (!willMute && v.paused) { v._svs.userPaused = false; this.playVideo(v, true); }
            });
          }
          v.addEventListener('volumechange', () => {
            media.classList.toggle('is-muted', v.muted);
            if (muteBtn) muteBtn.setAttribute('aria-pressed', String(!v.muted));
          });
        });

        // Start preloading neighbouring videos once the section is close to the viewport
        this.viewObs = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting && !this.loadObs) {
              this.loadObs = new IntersectionObserver((ents) => {
                ents.forEach((en) => {
                  if (en.isIntersecting) { this.loadVideo(en.target); this.loadObs.unobserve(en.target); }
                });
              }, { root: this.track, rootMargin: '0px 60% 0px 60%' });
              this.videos.forEach((v) => this.loadObs.observe(v));
              this.viewObs.disconnect();
            }
          });
        }, { rootMargin: '300px 0px' });
        this.viewObs.observe(this);

        this.visObs = new IntersectionObserver((entries) => {
          entries.forEach((e) => { this.inView = e.isIntersecting; });
        }, { threshold: 0.25 });
        this.visObs.observe(this);

        // Play videos that are actually on screen, pause the rest
        this.playObs = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            const v = e.target;
            const visible = e.isIntersecting && e.intersectionRatio >= 0.55;
            if (visible) {
              if (this.cfg.autoplay && !v._svs.userPaused) this.playVideo(v, false);
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: [0, 0.55, 1] });
        this.videos.forEach((v) => this.playObs.observe(v));
      }

      loadVideo(v) {
        if (v._svs.loaded) return;
        v._svs.loaded = true;
        v.querySelectorAll('source[data-src]').forEach((s) => {
          s.src = s.dataset.src;
          s.removeAttribute('data-src');
        });
        v.load();
      }

      playVideo(v, manual) {
        this.loadVideo(v);
        if (manual && !this.cfg.autoplay) {
          this.videos.forEach((o) => {
            if (o !== v && !o.paused) { o._svs.userPaused = true; o.pause(); }
          });
        }
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }

      /* ---------------- Slider navigation ---------------- */
      initNav() {
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.updateNav());
        }, { passive: true });
        this.ro = new ResizeObserver(() => this.buildDots());
        this.ro.observe(this.track);
        this.buildDots();
      }

      metrics() {
        const t = this.track;
        const first = this.slides[0];
        const gap = parseFloat(getComputedStyle(t).columnGap) || 0;
        const step = first ? first.getBoundingClientRect().width + gap : t.clientWidth;
        const max = Math.max(0, t.scrollWidth - t.clientWidth);
        return { step: step || 1, max: max };
      }

      positions() {
        const m = this.metrics();
        return m.max <= 2 ? 1 : Math.ceil((m.max - 2) / m.step) + 1;
      }

      current() {
        const m = this.metrics();
        const x = this.track.scrollLeft;
        if (x >= m.max - 2) return this.positions() - 1;
        return Math.round(x / m.step);
      }

      goTo(i) {
        const m = this.metrics();
        this.track.scrollTo({ left: Math.min(Math.max(0, i) * m.step, m.max), behavior: 'smooth' });
      }

      go(dir) { this.goTo(this.current() + dir); }

      buildDots() {
        const n = this.positions();
        this.classList.toggle('svs--static', n <= 1);
        if (this.dotsWrap && this.dotsWrap.children.length !== n) {
          this.dotsWrap.innerHTML = '';
          for (let i = 0; i < n; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'svs__dot';
            b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            b.addEventListener('click', () => this.goTo(i));
            this.dotsWrap.appendChild(b);
          }
        }
        this.updateNav();
      }

      updateNav() {
        const i = this.current();
        const n = this.positions();
        if (this.prevBtn) this.prevBtn.disabled = i <= 0;
        if (this.nextBtn) this.nextBtn.disabled = i >= n - 1;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((dot, idx) => {
            dot.setAttribute('aria-current', idx === i ? 'true' : 'false');
          });
        }
      }

      initAutoSlide() {
        if (!this.cfg.autoSlide) return;
        const hold = () => { this.hovering = true; };
        const release = () => { this.hovering = false; };
        this.addEventListener('pointerenter', hold);
        this.addEventListener('pointerleave', release);
        this.addEventListener('focusin', hold);
        this.addEventListener('focusout', release);
        this.track.addEventListener('touchstart', () => { this.hovering = true; clearTimeout(this.touchTimer); }, { passive: true });
        this.track.addEventListener('touchend', () => {
          this.touchTimer = setTimeout(() => { this.hovering = false; }, 4000);
        }, { passive: true });

        this.timer = setInterval(() => {
          if (this.hovering || this.paused || this.panelOpen || !this.inView || document.hidden) return;
          const n = this.positions();
          if (n <= 1) return;
          const i = this.current();
          this.goTo(i >= n - 1 ? 0 : i + 1);
        }, this.cfg.interval);
      }

      /* ---------------- Theme editor ---------------- */
      initEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        this.onBlockSelect = (e) => {
          const slide = this.querySelector('[data-block-id="' + e.detail.blockId + '"]');
          if (!slide) return;
          this.paused = true;
          this.track.scrollTo({ left: Math.min(slide.offsetLeft, this.metrics().max), behavior: 'smooth' });
        };
        this.onBlockDeselect = (e) => {
          if (this.querySelector('[data-block-id="' + e.detail.blockId + '"]')) this.paused = false;
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    customElements.define('shoppable-video-slider', ShoppableVideoSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vela-template-article"]) return;
  try {
    
    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.12';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));


  } catch(e) { console.error(e); }
})();
})();
